var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"margin-t10"},[_c('van-button',{attrs:{"round":"","block":"","type":"info","native-type":"submit"},on:{"click":_vm.confirm}},[_vm._v("确定")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }